module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.c300fff4.ttf";